export default __webpack_public_path__ + "static/media/avatar_3.34fe8c46.svg";